import { Component, ComponentChild } from 'preact';
import { createPortal } from 'preact/compat';
import { PopoutDocumentContext, type PopoutTarget } from '@brainfocus/web/shared/platform/popout_context';
import { FLOATING_LAYER_CLASS } from '@brainfocus/web/shared/platform/outside_click';
import './dialog_window.scss';

export class DialogWindow extends Component<DialogWindowProps> {

    /**
     * The dialog is portaled, so it needs its target BEFORE any element of its
     * own exists — hence the context rather than an `ownerDocument` read. It
     * appears inside the detachable sEEG section (the channel-layout dialog), so
     * a detached section must get its dialog in its OWN window (#761).
     */
    public static override contextType = PopoutDocumentContext;

    public override render(): ComponentChild {
        const target = (this.context as PopoutTarget | null)?.doc.body ?? document.body;
        return createPortal(
            <div class={`bf-dialog-window-backdrop ${FLOATING_LAYER_CLASS}`} onClick={this.props.onClose}>
                <div class='bf-dialog-window-content' onClick={e => e.stopPropagation()}>
                    {this.props.children}
                </div>
            </div>, target);
    }

}

export interface DialogWindowProps {
    onClose: () => void;
}
